<template>
  <div class="w-full mb-sm" v-if="errorMessage">
    <Transition name="slide">
      <div class="ease-in duration-600 p-twenty mt-sm bg-warning2 text-whiteOverride text-center rounded-lg">
        <ExclamationTriangleIcon class="mr-base" />
        <span data-test="error" >{{ errorMessage }}</span>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'PublicPageValidationError',
  props: {
    errorMessage: {
      type: String,
    },
  },
  components: {
    ExclamationTriangleIcon,
  },
};
</script>
